import clsx from "clsx";
import { sortBy } from "lodash";

import { makeStatuses } from "@north-beam/nb-client-side/metrics-v2";

import { type ReportDataRow } from "../types";

interface Props {
  row: ReportDataRow;
}

export const StatusCell = ({ row }: Props) => {
  const statusesMetric = makeStatuses();
  const statuses = sortBy(
    statusesMetric.getValue(row.data.actualMetrics) ?? [],
  );

  return (
    <div className="h-full px-2 flex items-center gap-2 text-xs">
      {statuses.map((status) => {
        return (
          <span
            key={status}
            className={clsx("py-0.5 px-2.5 rounded capitalize", {
              "bg-alien-2 text-[#3B8139]": status === "active",
              "bg-interstellar-3": status !== "active",
            })}
          >
            {status}
          </span>
        );
      })}
    </div>
  );
};
